//@ts-check
import { renderAllSections } from './js-utils-rendersection.js'
import { initB2bQuantityPricing } from './js-c-b2b-quantity-pricing.js'

class CVariants extends HTMLElement {
  constructor() {
    super()
    /** @type {HTMLLinkElement[]|null} */
    this.linkVariants = Array.from(this.querySelectorAll('[data-variants]'))
    this.btnSticky = [...document.querySelectorAll('.product-btn-sticky')]
    this.type = this.dataset.type || null
    this.sectionsRender = [
      {
        title: `${this.btnSticky[0]?.id}`,
        selector: ['[data-render-btn-sticky]'],
      },
      {
        title: `${this.btnSticky[1]?.id}`,
        selector: ['[data-render-btn-sticky]'],
      },
      {
        title: 'product',
        selector: [
          '[data-render-price]',
          '[data-render-quantity]',
          '[data-render-btn-add-product]',
          '[data-render-panel-contact]',
          '[data-render-panel-product]',
          '[data-render-variants-options-type]',
          '[data-render-panel-product-options-2]',
          '[data-render-card-option]',
        ],
      },
    ]
    this.sectionsRenderOption2 = [
      {
        title: 'product',
        selector: [
          '[data-render-panel-contact]',
          '[data-render-panel-product-options-2]',
        ],
      },
      {
        title: 'cart-drawer',
        selector: ['[data-render-panel-product-options-2]'],
      },
    ]
  }

  connectedCallback() {
    this.linkVariants?.forEach((link) => {
      link.addEventListener('click', async (e) => {
        e.preventDefault()
        const url = new URL(link.href)
        await this.handleChangeVariant(url, link)
      })
    })
  }
  async handleChangeVariant(url, link) {
    if (this.type == 'variants-options-2') {
      const form = this.closest('c-product-form')
      const inputVariantId = form?.querySelector(
        'input[type="hidden"][name*="id"]'
      )
      const inputPropertyMethod = form?.querySelector(
        'input[type="hidden"][name*="_send_method"]'
      )
      const inputParentIds = form?.querySelectorAll(
        'input[type="hidden"][data-parent-id]'
      )
      const message = this.querySelector('[data-message-courrier]')

      const value = link.dataset.value
      const id = link.dataset.id

      if (inputVariantId) {
        inputVariantId.value = id
      }
      if (inputPropertyMethod) {
        inputPropertyMethod.value = value
      }
      if (inputParentIds && inputParentIds.length > 0) {
        inputParentIds.forEach((input) => {
          input.value = id
        })
      }

      this.linkVariants?.forEach((link) => {
        link.classList.remove('is-active')
      })
      link.classList.add('is-active')
      if (value.includes('courrier')) {
        message?.classList.add('is-show')
      } else {
        message?.classList.remove('is-show')
      }
    } else {
      history.pushState('', '', `${url.href}`)
      await renderAllSections(this.sectionsRender, url)
      initB2bQuantityPricing()
    }
  }
  disconnectedCallback() {}
}
if (!customElements.get('c-variants')) {
  customElements.define('c-variants', CVariants)
}
